import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Composants
import PageHero from '../components/layout/PageHero';
import Batiment from '../components/construction/Batiment';
import GenieCivil from '../components/construction/GenieCivil';
import Amenagement from '../components/construction/Amenagement';

const BTP = () => {
  const { t } = useTranslation();

  // Mise à jour du titre de la page
  useEffect(() => {
    document.title = `${t('header.construction')} | SOCABEG`;
  }, [t]);

  return (
    <div>
      <PageHero 
        backgroundImage="images/hero_btp.png"
        title={t('construction.hero.title')}
        subtitle={t('construction.hero.subtitle')}
        overlayColor="socabeg-blue"
        textPosition="left"
      />
      <div className="pt-8">
        <div><Batiment /></div>
        <div><GenieCivil /></div>
        <div><Amenagement /></div>
      </div>
    </div>
  );
};

export default BTP;
